let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("e41T5")).then(() => parcelRequire('95iLR'));